import React from 'react';
import { Grid, Divider } from '@material-ui/core';
import AcceptQuote from './AcceptQuote';
import DeclineQuote from './DeclineQuote';
import RequestChangesOnQuote from './RequestChangesOnQuote';
import useStyles from '../useStyles';

const QuoteAcceptance = function QuoteAcceptance(): React.ReactElement {
  const classes = useStyles();

  return (
    <>
      <Grid item>
        <AcceptQuote />
      </Grid>
      <Grid item>
        <DeclineQuote />
      </Grid>
      <Divider
        className={classes.bottomButtonsDivider}
        orientation='vertical'
        flexItem
      />
      <Grid item>
        <RequestChangesOnQuote />
      </Grid>
    </>
  );
};

export default QuoteAcceptance;
